import { useVectorCapitalSimulator } from '../VectorCapitalSimulatorContext';

export default function VcDisclosuresWidget() {
  const sim = useVectorCapitalSimulator();
  return sim.renderDisclosures();
}
